import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link, Text } from '@paygreen/paygreen-ui';
import {
    getDataFromObject,
    fixExternalUrl,
    truncateTooLongName,
    shortExternalUrl,
} from '../../../utils/tools';
import { LineKeyValue } from '../../../components';
import { CardInfo } from '../shared';
import { companyManagementList } from '../shared';
import UserDisplayBillingData from '../../user/company/UserDisplayBillingData';

const CompanyManagementCard = ({ t, isLoading, accountData }) => (
    <CardInfo isLoading={isLoading} title={t('admin.user.companyInfos.title')}>
        {companyManagementList.map((item, index) => {
            const { name, value, type } = item;

            return (
                <LineKeyValue
                    key={index}
                    hasUppercase={false}
                    keyLabel={t('admin.user.companyInfos.' + name + 'Input')}
                    keyValue={
                        accountData && getDataFromObject(value, accountData)
                    }
                    textSize="xs"
                >
                    {type === 'link' && (
                        <a
                            href={fixExternalUrl(
                                getDataFromObject(value, accountData),
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text textSize="xs">
                                <Link colorTheme="secondary">
                                    {truncateTooLongName(
                                        shortExternalUrl(
                                            getDataFromObject(
                                                value,
                                                accountData,
                                            ),
                                        ),
                                        25,
                                    )}
                                </Link>
                            </Text>
                        </a>
                    )}
                </LineKeyValue>
            );
        })}

        <LineKeyValue
            hasUppercase={false}
            keyLabel={t('user.company.billingAddress.SHOP')}
            keyValue={accountData?.organisationAddress?.addressLine1}
            textSize="xs"
        >
            <UserDisplayBillingData
                data={accountData?.organisationAddress}
                isLoading={isLoading}
                hasLabel={false}
            />
        </LineKeyValue>
    </CardInfo>
);

CompanyManagementCard.propTypes = {
    isLoading: PropTypes.bool,
    accountData: PropTypes.object,
};

CompanyManagementCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(CompanyManagementCard);
